export const lpMock = {
    "id": "740ee6ef-3af0-4095-9dad-1469e225bc03",
    "name": "Certificación de lapzo",
    "description": "Certificación en el uso correcto de lapzo y todos sus productos ",
    "imageUrl": "https://firebasestorage.googleapis.com/v0/b/lernit-v2.appspot.com/o/voldemort%2Ftopics%2Fimages%2F1736285816251.png?alt=media&token=e51344cc-a159-40fc-ad70-5c42e6b070c8",
    "sections": [
        {
            "sectionName": "Sección 1",
            "sectionIndex": 0,
            "courses": [
                {
                    "courseId": "38ad4081-e0dc-441d-9297-94b66b15aab4",
                    "courseIndex": 0,
                    "courseName": "Introductorio, y plataforma General ",
                    "courseDuration": "2.00",
                    "courseStatus": "NOT_STARTED",
                    "userProgress": 100,
                    "coursesAllProgress": 100,
                    "userScore": 92,
                    "minScore": 70,
                    "minProgress": 100,
                    "completedAt": "2025-02-27T15:16:04.580Z",
                    "courseEndDate": null,
                    "courseStartDate": null,
                    "certificate": null,
                    "image_url": false,
                    "clientId": "7b8cb75d-e6e5-4593-a970-f85fb313b9cf",
                    "accreditation_qualtrics": {},
                    "groups": [],
                    "hasDatedModules": false,
                    "hasGroups": false,
                    "releaseDate": null,
                    "availableDate": null,
                    "userSubscribed": true,
                    "modulesCount": 2
                },
                {
                    "courseId": "a43a5eb1-f4a1-4454-bd76-a642649c145c",
                    "courseIndex": 1,
                    "courseName": "Módulo de Capacitación y Aprendizaje",
                    "courseDuration": "3.00",
                    "courseStatus": "IN_PROGRESS",
                    "userProgress": 100,
                    "coursesAllProgress": 100,
                    "userScore": 95,
                    "minScore": 70,
                    "minProgress": "100",
                    "completedAt": "2025-03-05T17:50:36.450Z",
                    "courseEndDate": null,
                    "courseStartDate": null,
                    "certificate": null,
                    "image_url": false,
                    "clientId": "7b8cb75d-e6e5-4593-a970-f85fb313b9cf",
                    "accreditation_qualtrics": {},
                    "groups": [],
                    "hasDatedModules": false,
                    "hasGroups": false,
                    "releaseDate": null,
                    "availableDate": null,
                    "userSubscribed": true,
                    "modulesCount": 5
                },
                {
                    "courseId": "22ebb750-914b-42a9-af6e-266867baace6",
                    "courseIndex": 2,
                    "courseName": "Módulo de Desarrollo por Competencias",
                    "courseDuration": "2.00",
                    "courseStatus": "APPROVED",
                    "userProgress": 100,
                    "coursesAllProgress": 100,
                    "userScore": 97,
                    "minScore": 70,
                    "minProgress": "100",
                    "completedAt": "2025-02-26T08:10:46.747Z",
                    "courseEndDate": null,
                    "courseStartDate": null,
                    "certificate": null,
                    "image_url": false,
                    "clientId": "7b8cb75d-e6e5-4593-a970-f85fb313b9cf",
                    "accreditation_qualtrics": {},
                    "groups": [],
                    "hasDatedModules": false,
                    "hasGroups": false,
                    "releaseDate": null,
                    "availableDate": null,
                    "userSubscribed": true,
                    "modulesCount": 4
                },
                {
                    "courseId": "28cde14a-4049-4e1a-a3a7-a04ec9a0f5cd",
                    "courseIndex": 3,
                    "courseName": "Módulo de Objetivos",
                    "courseDuration": "3.00",
                    "courseStatus": "APPROVED_AFTER",
                    "userProgress": 100,
                    "coursesAllProgress": 100,
                    "userScore": 91,
                    "minScore": 70,
                    "minProgress": "100",
                    "completedAt": "2025-02-26T18:23:20.953Z",
                    "courseEndDate": null,
                    "courseStartDate": null,
                    "certificate": null,
                    "image_url": false,
                    "clientId": "7b8cb75d-e6e5-4593-a970-f85fb313b9cf",
                    "accreditation_qualtrics": {},
                    "groups": [],
                    "hasDatedModules": false,
                    "hasGroups": false,
                    "releaseDate": null,
                    "availableDate": null,
                    "userSubscribed": true,
                    "modulesCount": 5
                },
                {
                    "courseId": "a20e0071-3552-4983-990d-4a716e333f6a",
                    "courseIndex": 4,
                    "courseName": "Módulo de Evaluaciones",
                    "courseDuration": "4.00",
                    "courseStatus": "FAILED",
                    "userProgress": 100,
                    "coursesAllProgress": 100,
                    "userScore": 88,
                    "minScore": 70,
                    "minProgress": "100",
                    "completedAt": "2025-02-26T14:59:13.219Z",
                    "courseEndDate": null,
                    "courseStartDate": null,
                    "certificate": null,
                    "image_url": false,
                    "clientId": "7b8cb75d-e6e5-4593-a970-f85fb313b9cf",
                    "accreditation_qualtrics": {},
                    "groups": [],
                    "hasDatedModules": false,
                    "hasGroups": false,
                    "releaseDate": null,
                    "availableDate": null,
                    "userSubscribed": true,
                    "modulesCount": 2
                },
                {
                    "courseId": "a20e0371-3552-4983-920d-4a716e333f6a",
                    "courseIndex": 4,
                    "courseName": "Módulo de Particiones",
                    "courseDuration": "4.00",
                    "courseStatus": "ACCREDITED",
                    "userProgress": 100,
                    "coursesAllProgress": 100,
                    "userScore": 88,
                    "minScore": 70,
                    "minProgress": "100",
                    "completedAt": "2025-02-26T14:59:13.219Z",
                    "courseEndDate": null,
                    "courseStartDate": null,
                    "certificate": null,
                    "image_url": false,
                    "clientId": "7b8cb75d-e6e5-4593-a970-f85fb313b9cf",
                    "accreditation_qualtrics": {},
                    "groups": [],
                    "hasDatedModules": false,
                    "hasGroups": false,
                    "releaseDate": null,
                    "availableDate": null,
                    "userSubscribed": true,
                    "modulesCount": 2
                }
            ],
            "userProgress": 100
        }
    ],
    "conditionedCourses": false,
    "conditionedSections": false,
    "minProgress": 80,
    "certificateDelivery": "LP_ONLY",
    "conditionDelivery": "LP_END",
    "welcomeMessage": "<p>Bienvenidos a la ruta de aprendizaje Certificaci&oacute;n de lapzo</p>",
    "userProgress": 100,
    "userId": "09a0b3d2-ddb1-44be-a2b5-f814f7fe5e6a",
    "duration": 14,
    "completedAt": "2025-03-05T17:50:36.450Z",
    "startDate": null,
    "endDate": null,
    "isDynamic": false,
    "validityDays": 0,
    "readyToStart": false,
    "progressStatus": "IN_PROGRESS",
    "status": "ACTIVE",
    "qualtrics": {},
    "qualtricsResponse": {},
    "isEnrolled": true,
    "userStartDate": "2025-02-06T04:31:49.369Z",
    "userEndDate": null,
    "forceFailOnEndDate": false
}